import { render, staticRenderFns } from "./FaqItem.vue?vue&type=template&id=80b765e6&"
import script from "./FaqItem.vue?vue&type=script&lang=js&"
export * from "./FaqItem.vue?vue&type=script&lang=js&"
import style0 from "./FaqItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports